import { render, staticRenderFns } from "./CompilaQuestionario.vue?vue&type=template&id=67e469de&"
import script from "./CompilaQuestionario.vue?vue&type=script&lang=js&"
export * from "./CompilaQuestionario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports